import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

interface IProps {
  name?: string;
  wrapperStyle?: CSSProperties;
  children?: ReactNode;
}

export const FieldGroup = styled.div<IProps>`
  ${(props: IProps) =>
    props.wrapperStyle?.paddingLeft !== undefined
      ? `padding-left: ${props.wrapperStyle.paddingLeft}px;`
      : ''}
`;
